enum Languages {
  English = 'en',
  Spanish = 'es',
  French = 'fr',
  German = 'de',
}

export default Languages
